import { CoreButton } from '@components'
import DetailIcon from '@images/icons/details-icon.svg?react'
import ListIcon from '@images/icons/list-icon.svg?react'
import cn from 'classnames'
import type React from 'react'

import './viewsSwitch.scss'

interface ConfigItem {
  name: string
  icon?: React.ComponentType
}

interface ViewSwitchProps {
  selected: string
  setSelected: (arg: unknown) => void
}

const switchConfig: ConfigItem[] = [
  { icon: ListIcon, name: 'list' },
  { icon: DetailIcon, name: 'detail' }
]

export const ViewsSwitch = ({ selected, setSelected }: ViewSwitchProps) => {
  const handleViewChange = (view: string) => setSelected(view)

  return (
    <div className='switch-container'>
      {switchConfig.map(({ icon: Icon, name }, index) => (
        <CoreButton
          variation='elevated'
          CollapsedIcon={<Icon />}
          collapsed
          key={index}
          className={`${cn({ active: selected === name })}`}
          onClick={() => handleViewChange(name)}
          size='normal'
        />
      ))}
    </div>
  )
}
